import { Target, Globe, Briefcase } from "lucide-react";

const features = [
  { icon: Target, text: "Ponad 27 lat na rynku eventowym" },
  { icon: Briefcase, text: "Dedykowane rozwiązania dla segmentu B2B" },
  { icon: Globe, text: "Realizacje w całej Polsce i za granicą" },
];

export const About = () => {
  return (
    <section id="about" className="py-24 section-white relative overflow-hidden">
      <div className="absolute inset-0 dot-pattern opacity-30" />
      <div className="container relative z-10">
        <h2 className="text-4xl md:text-5xl font-outfit font-bold text-center mb-4 text-foreground">
          Kim <span className="text-gradient">jesteśmy?</span>
        </h2>
        <p className="text-muted-foreground text-center mb-16 max-w-md mx-auto">
          Twój partner w tworzeniu wydarzeń, o których się mówi
        </p>

        <div className="max-w-4xl mx-auto card-highlight p-8 md:p-12">
          <p className="text-lg mb-6 text-muted-foreground leading-relaxed">
            WystepyFirmowe.pl to platforma łącząca organizatorów eventów firmowych z najlepszymi 
            artystami i atrakcjami w Polsce. Nasz zespół specjalistów eventowych pomaga dobrać 
            idealne rozwiązania rozrywkowe dopasowane do charakteru Twojego wydarzenia biznesowego.
          </p>
          <p className="text-lg mb-8 text-muted-foreground leading-relaxed">
            Współpracujemy wyłącznie ze zweryfikowanymi wykonawcami, gwarantując najwyższy standard 
            realizacji. Od kameralnych spotkań zarządu po wielotysięczne gale korporacyjne - 
            zapewniamy atrakcje, które robią wrażenie.
          </p>

          <div className="grid sm:grid-cols-3 gap-4">
            {features.map((f) => {
              const Icon = f.icon;
              return (
                <div key={f.text} className="flex items-center gap-3 p-4 rounded-xl bg-primary/5 border border-primary/10">
                  <Icon className="w-5 h-5 text-primary flex-shrink-0" />
                  <span className="text-sm text-foreground font-medium">{f.text}</span>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
};
